<div class="header-container left-container" [ngClass]="iconTypeLayoutClass()">
  <div class="logo-container">
    <a (click)="openModalMenu()" class="sidebar-toggle pr-4" *ngIf="this.menu?.menuitems?.length"
      [attr.aria-label]="getTranslate('openMenu')">
      <img [src]="exists(menu) && exists(menu.image) ? menu.image : '/assets/images/bt-menu.svg'" width="27px"
        height="27px" class="mr-1">
    </a>
    <a href="#" class="sidebar-toggle pr-4" *ngIf="!this.menu?.menuitems?.length">
    </a>
    <a class="logo" href="#" (click)="navigateHome()" aria-label="Ir para home">
      <img src="assets/images/img-logo-horiz.webp">
    </a>

    <ul class="header-menu header-nav" *ngIf="headerMenu">

      <li class="control-item" [ngClass]="headerMenuItemClass('produtos')"
        *ngIf="enableTimeline && headerMenuItems > 1">
        <a [routerLink]="'/produtos'" class="header-menu-item" aria-label="Ir para produtos">
          <span class="menu-icon status-home" aria-hidden="true"></span>
          <span class="menu-label">{{ getTimelineLabel() }}</span>
        </a>
      </li>

      <li class="control-item" [ngClass]="headerMenuItemClass('explorar')" *ngIf="enableExplore && headerMenuItems > 1">
        <a [routerLink]="'/explorar'" class="header-menu-item" aria-label="Ir para explorar">
          <span class="menu-icon status-explorar" aria-hidden="true"></span>
          <span class="menu-label">{{ getExploreLabel() }}</span>
        </a>
      </li>

      <li class="control-item" [ngClass]="headerMenuItemClass('comunidade')"
        *ngIf="enableSocialMedia && headerMenuItems > 1">
        <a [routerLink]="isAuthenticated() ? '/comunidade' : '/login'" class="header-menu-item"
          aria-label="Ir para comunidade">
          <span class="menu-icon status-comunidade" aria-hidden="true"></span>
          <span class="menu-label">{{ getSocialMediaLabel() }}</span>
        </a>
      </li>

      <li class="control-item" [ngClass]="activeMenu ? 'active': ''" *ngIf="this.menu?.menuitems?.length">
        <a (click)="openModalMenu()" class="header-menu-item" style="cursor: pointer;"
          [attr.aria-label]="getTranslate('openAppMenu')">
          <span class="menu-icon status-menu" aria-hidden="true"></span>
          <span class="menu-label">{{ getTranslate("menu") }}</span>
        </a>
      </li>
    </ul>

  </div>
</div>

<div class="header-container right-container" [ngClass]="iconTypeLayoutClass()" [class.logged-out]="!isAuthenticated()">
  <ul class="header-menu utility-nav">

    <li class="control-item" [ngClass]="isOnCommunity() ? headerMenuItemClass('pesquisa') : headerMenuItemClass('buscar')" *ngIf="enableSearchButton">
      <a [routerLink]="searchRoute()" class="header-menu-item search-item" aria-label="Buscar">
        <span class="search-trigger-icon" aria-hidden="true"></span>
        <span class="menu-label">{{ searchLabel() }}</span>
      </a>
    </li>

  </ul>

  <div class="header-user-actions" *ngIf="isAuthenticated() && exists(user)">
    <button type="button" class="menu-trigger-mobile"
      *ngIf="this.menu?.menuitems?.length"
      (click)="openModalMenu()"
      [attr.aria-label]="getTranslate('openMenu')">
      <img [src]="exists(menu) && exists(menu.image) ? menu.image : '/assets/images/bt-menu.svg'" width="25px" height="25px">
    </button>
    <button type="button" class="search-trigger-mobile"
      *ngIf="enableSearchButton" [routerLink]="searchRoute()"
      aria-label="Ir para busca" [class.active]="isOnCommunity() ? isRouteActive('pesquisa') : isRouteActive('buscar')">
      <span class="search-trigger-icon" aria-hidden="true"></span>
    </button>
    <button type="button" class="notification-trigger" [class.active]="isNotificationsRoute()"
      (click)="navigateNotifications()" aria-label="Ir para notificações">
      <span class="notification-icon" [class.has-notifications]="hasNotifications()" aria-hidden="true"></span>
      <span class="notification-badge" *ngIf="hasNotifications()"></span>
    </button>

    <nb-actions size="small">
      <nb-action class="user-action" *nbIsGranted="['view', 'user']">
        <nb-user *ngIf="userMenu.length" [nbContextMenu]="userMenu" [name]="firstName(user?.name)" [size]="'small'"
          [picture]="user?.image || this?.home?.holder_avatar || './assets/images/ic-avatar-register.svg'">
        </nb-user>
      </nb-action>
    </nb-actions>
  </div>
  <div class="logo-container" *ngIf="!isAuthenticated()">
    <a class="menu-login" href="#" (click)="navigateLogin()" aria-label="Entrar">
      {{ getTranslate("signIn") }}
    </a>
  </div>
</div>